import React, { useState } from 'react';
import { withFormulas } from '../../hocs/with-formulas';
import './health-assesment-score.scss';
import {
  ScoreCostsWithFormulas,
  ScoreCashFlowWithFormulas,
  ScoreScalabilityWithFormulas,
  ScoreResilienceWithFormulas
} from '../../pages/index';

export const HealthAssesmentScore = ({ formulas }) => {
  const [ isTitleOpen, setIsTitleOpen ] = useState(false);
  const [ tabOpen, setOpenTab ] = useState("AR-COSTS");
  const tabCostsClass = tabOpen === "AR-COSTS" ? "tab active" : "tab unactive";
  const tabCashFlowClass = tabOpen === "CASH_FLOW" ? "tab active" : "tab unactive";
  const tabScalabilityClass = tabOpen === "SCALABILITY" ? "tab active" : "tab unactive";
  const tabResilienceClass = tabOpen === "RESILIENCE" ? "tab active" : "tab unactive";
  const aTitleScore = "Congratulations!!";
  const bTitleScore = "Nice Job!";
  const cTitleScore = "Not bad";
  const dTitleScore = "Concerning";
  const fTitleScore = "Danger";
  const aTextScore = "Your overall AR Health is excellent. Compared to your peers and industry benchmarks, your Accounts Receivable processes and costs are much better than average. But, there’s still opportunity for improvement to build an efficient and truly scalable AR operation."
  const bTextScore = "Your overall AR Health is on solid ground. Compared to your peers and industry benchmarks, your Accounts Receivable processes and costs are satisfactory. But there’s clear room for improvement and opportunity to create best-in-class payment processes for your company."
  const cTextScore = "Your overall AR Health is about average compared to your peers and the industry. Given your results, there is significant room for improvement and with several key changes you can begin making progress toward an efficient, high-performing Accounts Receivable process."
  const dTextScore = "Your overall AR Health is below average compared to your peers and the industry. But, you have an opportunity for immediate improvement. With several key changes to your operations, you can begin making progress toward an efficient, high-performing Accounts Receivable process."
  const fTextScore = "Your overall AR Health is far below average compared to your peers and the industry. But, you have an opportunity for immediate improvement. With several key changes to your operations, you can begin making progress toward an efficient, high-performing Accounts Receivable process."

  const handleChangeTab = (tab) => {
    setOpenTab(tab)
  };

  const handleTitleOpen = () => {
    setIsTitleOpen(!isTitleOpen);
  }

  const copyLinkToClipboard = () => {
    const textField = document.createElement('textarea');
    textField.innerHTML = "https://www.paystand.com/AR-Health";

    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();

    var snackbar = document.getElementById("snackbar");
    snackbar.className = "show";
    setTimeout(function(){ snackbar.className = snackbar.className.replace("show", ""); }, 2000);
  }

  const shareGrade = () => {
  }

  const scoreCosts = formulas.getArCostsScore();
  const scoreCashFlow = formulas.getCashFlowScore();
  const scoreScalability = formulas.getScalabilityScore();
  const scoreResilience = formulas.getResilienceScore();
  const scoreOverall = formulas.getOverallGrade();

  const getOverallTitileScore = () => {
    let overallTitleScore;
    if (scoreOverall === "a") {
      overallTitleScore = aTitleScore;
    } else if (scoreOverall === "b") {
      overallTitleScore = bTitleScore;
    } else if (scoreOverall === "c") {
      overallTitleScore = cTitleScore;
    } else if (scoreOverall === "d") {
      overallTitleScore = dTitleScore;
    } else if (scoreOverall === "f") {
      overallTitleScore = fTitleScore;
    }

    return overallTitleScore;
  }

  const getOverallTextScore = () => {
    let overallTextScore;
    if (scoreOverall === "a") {
      overallTextScore = aTextScore;
    } else if (scoreOverall === "b") {
      overallTextScore = bTextScore;
    } else if (scoreOverall === "c") {
      overallTextScore = cTextScore;
    } else if (scoreOverall === "d") {
      overallTextScore = dTextScore;
    } else if (scoreOverall === "f") {
      overallTextScore = fTextScore;
    }

    return overallTextScore;
  }

  return (
    <section className="health-assesment-score">
      <header>
        <div className="headline">
          <h6>Overall AR Health Score</h6>
          <h1>Your AR Health Assessment Grade</h1>
          <div className="powered-by">
            <span className="text-06-navy-blue-italic">
              Powered by
            </span>
            <img src={require("../../../styles/img/blue.png")} style={{width: "55px"}} alt="logo"/>
          </div>
        </div>

        <div className="score-section">
          <img src={require(`../../../styles/img/${scoreOverall}_big-score.png`)} alt="score-a"/>
          <div className="share-btn">
            <span className="caption-01-gray-90-uppercase">Share this with your colleagues</span>
            <button onClick={shareGrade}>Share this grade</button>
          </div>
        </div>

        <div className="text-area">
          <h3>Overall Assessment: <span className="score-title">{getOverallTitileScore()}</span></h3>
          <p>{getOverallTextScore()}</p>
          <h3>What can you do?</h3>
          <p>Take a look at your four category results below to see actionable recommendations for decreasing costs, improving cash flow, building scalable processes, and creating a more resilient finance team.</p>

          <div className="how-calculation">
            <div onClick={handleTitleOpen} className="title text-03-sky-blue-bold">
              <h5>How is my score calculated?</h5>
              <i className={`fa fa-angle-${isTitleOpen ? 'up' : 'down'}`}></i>
            </div>
            <p className={`${isTitleOpen ? 'show' : 'hide'}`}>Your Paystand AR Health Score(TM) is calculated by a weighted average of four key scoring categories: AR Costs, Cash Flow, Scalability, and Resiliency. Each category is scored according to your answers with standardized point values corresponding to your responses. The points in each category determine your category grade, which are then weighted to determine your final score.</p>
          </div>
        </div>
      </header>

      <span className="title-sub-grades">Category Grades</span>
      <div className="sub-grades">
        <nav>
          <div className={tabCostsClass} onClick={() => handleChangeTab("AR-COSTS")}>
            <img src={require(`../../../styles/img/${scoreCosts}_score.png`)} style={{width: "55px"}} alt="score-a"/>
            <span>AR Costs</span>
          </div>
          <div className={tabCashFlowClass} onClick={() => handleChangeTab("CASH_FLOW")}>
            <img src={require(`../../../styles/img/${scoreCashFlow}_score.png`)} style={{width: "55px"}} alt="score-a"/>
            <span>Cash Flow</span>
          </div>
          <div className={tabScalabilityClass} onClick={() => handleChangeTab("SCALABILITY")}>
            <img src={require(`../../../styles/img/${scoreScalability}_score.png`)} style={{width: "55px"}} alt="score-a"/>
            <span>Scalability</span>
          </div>
          <div className={tabResilienceClass} onClick={() => handleChangeTab("RESILIENCE")}>
            <img src={require(`../../../styles/img/${scoreResilience}_score.png`)} style={{width: "55px"}} alt="score-a"/>
            <span>Resilience</span>
          </div>
        </nav>

        <main>
          <div className="score-results">
            <ScoreCostsWithFormulas className={tabCostsClass} />
            <ScoreCashFlowWithFormulas className={tabCashFlowClass} />
            <ScoreScalabilityWithFormulas className={tabScalabilityClass} />
            <ScoreResilienceWithFormulas className={tabResilienceClass} />
          </div>
        </main>

      </div>
      <footer>
        <span className="title">Invite others to take this AR Health Assessment!</span>
        <div className="copy-container">
          <div className="link">
            <i className="fa fa-link"></i>
            <div className="url-link">https://www.paystand.com/AR-Health</div>
          </div>
          <button onClick={copyLinkToClipboard}>
            Copy
          </button>
          <div id="snackbar">Link copied!</div>
        </div>
      </footer>
    </section>
  )
}

export const HealthAssesmentScoreWithFormulas = withFormulas(HealthAssesmentScore);
